import Zaui from '@/include/api';
import PortalSettings from '@/models/PortalSettings';
import Agent from '@/models/Agent';

export default {

  // fetch the app settings with the given portal context. 
  // we get back a PortalSettings and possibly an Agent that is currently logged in.
  fetch(portal) {
    Zaui.setPortal(portal);
    
    return Zaui.settings.all().then(result => {
      // Going forward we use the portalId for API calls
      Zaui.setPortal(result.portal.id);

      // lets check to see if we already have a uuid in local storage. 
      let uuid = window.localStorage ? localStorage.getItem('zaui-uuid') : null;
      if (!uuid) {
        uuid = result.portal.uuid;
      }
      Zaui.setUUID(uuid);
      if (window.localStorage) {
        localStorage.setItem('zaui-uuid', uuid);
      }

      if (result.agent) {
        Agent.create({ data: result.agent });
      }

      return PortalSettings.create({ data: result.portal }).then(entities => {
        return entities.portalsettings[0];
      });
    }).catch(err => {
      console.log('catch', err);
      return new PortalSettings({ valid: false });
    });    
  },

  applyTheme(ps) {
    if (ps.themeFontFamily) {
      const url = `https://fonts.googleapis.com/css?family=${ps.themeFontFamily}:400,500,700`;
      const link = document.createElement('link');
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = url;
      document.head.appendChild(link);
      document.documentElement.style.setProperty('--theme-font-family', `'${ps.themeFontFamily}'`);
    }
    if (ps.themePrimaryColor) {
      document.documentElement.style.setProperty('--theme-color-primary', ps.themePrimaryColor);
    }
    if (ps.themeSecondaryColor) {
      document.documentElement.style.setProperty('--theme-color-secondary', ps.themeSecondaryColor);
    }
    if (ps.themeCtaColor) {
      document.documentElement.style.setProperty('--theme-color-cta', ps.themeCtaColor);
    }
  }
}